// web/src/components/atoms/RadioOption.tsx — DS.7 (sprint
// aos-ds-settings-modals, spec §2 D7 / D15).
//
// A `value` + `label` adapter over `@ds/data-input/RadioButton`. THE PUBLIC
// SHAPE CHANGES, deliberately and in one direction: the piece reads
// `name`/`value`/`onChange` from a `RadioGroupContext`
// `[medido: RadioButton.tsx:96-99]`, so THE CALL SITE OWNS THE GROUP. An
// independent option cannot be wrapped by a group it does not know about, and
// synthesising one inside the atom would give the selected value two sources
// of truth.
//
// What the app GAINS by the change, asserted rather than claimed: the group
// handles ArrowDown/ArrowUp/ArrowRight/ArrowLeft with wrapping over
// `input[type="radio"]:not(:disabled)` (RadioButton.tsx:49-70), which the
// three bespoke buttons never did. `RadioOption.test.tsx`'s fourth case is
// that behaviour, not this sentence.
//
// Rendering one OUTSIDE a group is a programming error and fails LOUDLY — the
// piece throws `RadioButton must be used inside a RadioGroup`
// (RadioButton.tsx:98). Level 4, not a silent no-op.
//
// `props: {checked, onCheckedChange, name} -> {value}`. The two enumerated
// assertion drops: `aria-checked` (a native radio expresses state through
// `checked`; asserting an ARIA mirror the piece does not set would be
// asserting a bug) and `border-action` (bespoke markup that no longer exists).

import RadioButton from '@ds/data-input/RadioButton';

export interface RadioOptionProps {
  /** The group value this option selects. */
  value: string;
  label: string;
  disabled?: boolean;
}

export function RadioOption({ value, label, disabled = false }: RadioOptionProps) {
  return <RadioButton value={value} label={label} disabled={disabled} />;
}
